module.exports = __webpack_public_path__ + "img/Vietnam-3-hover.40e58266.jpg";